import { context } from '@wikia/ad-engine';

export function getMedianetContext(): object {
	const floorAdhesionConfigs = context.get('experiments.persistentAdhesionExperiment')
		? {
				adhesion_limited: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.adhesion_limited ?? [
						[300, 50],
						[320, 50],
					],
					cid: '8CU5JOKX4',
					crid: '476381130',
				},
			}
		: {
				floor_adhesion: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.floor_adhesion ?? [
						[300, 50],
						[320, 50],
						[320, 100],
					],
					cid: '8CU5JOKX4',
					crid: '476381130',
				},
			};

	return {
		enabled: false,
		slots: {
			top_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.mobile_top_leaderboard ?? [
					[320, 50],
					[320, 100],
				],
				cid: '8CU5JOKX4',
				crid: '365183821',
			},
			top_boxad: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.top_boxad ?? [
					[300, 250],
					[320, 50],
				],
				cid: '8CU5JOKX4',
				crid: '730485468',
			},
			...floorAdhesionConfigs,
		},
	};
}
